/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Status_FrozenInputs */

const fr_membership_status_frozen = /** @type {(inputs: Membership_Status_FrozenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En pause (freeze)`)
};

/**

* @param {Membership_Status_FrozenInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_status_frozen = /** @type {((inputs?: Membership_Status_FrozenInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Status_FrozenInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_status_frozen(inputs)
});